module.exports = __webpack_public_path__ + "img/search-header-with-nav-cjdr.317127ff.png";